/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const colors = {
    deep: '#EA580C',
    medium: '#FB923C',
    light: '#FED7AA',
    mediumAreaFill: '#FB923C',
    deepStroke: '#ea580c',
    mediumStroke: '#f57b29',
    cartesianGrid: '#EAEAEA',
    totalOrderLine: '#2563EB',
    filterTextColor: '#18181B',
    infoColor: '#71717A',
    unCheckedRadioButton: '#E4E4E7',
    dateRangeColor: '#F4F4F5',
}

export const fonts = {
    fontFamily: 'Inter, sans-serif'
}

export const styles = {
    boxShadow: '0px 1px 3px 0px #0000001A'
}
